"use strict";
/**
 * @description Line，有序的线图
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var path_1 = require("./path");
var Line = /** @class */ (function (_super) {
    tslib_1.__extends(Line, _super);
    function Line(cfg) {
        return _super.call(this, tslib_1.__assign({ type: 'line', sortable: true }, cfg)) || this;
    }
    return Line;
}(path_1.default));
exports.default = Line;
//# sourceMappingURL=line.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/line.js
// module id = 811
// module chunks = 37